import { SHOW_SEE_A_PATIENT } from 'src/featureFlags/currentFlags';
import { useFeatureFlag } from 'src/featureFlags/useFeatureFlag';
import { Provider } from 'src/shared/stores/resource';
import useRootStore from 'src/stores/useRootStore';

export default function useShowSeePatientNowButton() {
  const isFeatureEnabled = useFeatureFlag(SHOW_SEE_A_PATIENT);
  const rootStore = useRootStore();
  const {
    auth: { user },
  } = rootStore;

  const isClinician = (user as Provider)?.teamRole === 'clinician';

  return isFeatureEnabled && isClinician;
}
